import { Box, Flex, HStack } from 'native-base';
import React, { ReactNode } from 'react';

export type BulletListItemProps = {
  children: ReactNode;
};

export default function BulletListItem({ children }: BulletListItemProps) {
  return (
    <Flex
      alignItems="flex-start"
      flexDirection="row"
      flexWrap="wrap"
      mb="2"
      testID="BulletListItem"
    >
      <Box bgColor="black" borderRadius="9999" h="4px" ml="1" mr="2" mt="2" w="4px" />
      <Box flex="1">{children}</Box>
    </Flex>
  );
}
